import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { toast } from "react-toastify";
import { deleteRolodexPerson, publishRolodexPerson } from "../../../redux/actions/rolodexActions";
import { AppDispatch } from "../../../redux/store";

interface DeleteRolodexDialogProps {
  open: boolean;
  onClose: () => void;
  personId: string;
}

const DeleteRolodexDialog: React.FC<DeleteRolodexDialogProps> = ({ open, onClose, personId }) => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const handleConfirmDelete = () => {
    if (!personId) return;
    
    onClose(); // Close the dialog
    
    dispatch(deleteRolodexPerson({ id: personId }))
      .unwrap()
      .then((deletedPerson) => {
        toast.success("Rolodex person marked as deleted!");
        
        // Automatically publish the deletion
        dispatch(publishRolodexPerson({ id: personId }))
          .unwrap()
          .then(() => {
            toast.success("Deletion published successfully!");
            // Navigate back to the list view
            navigate("/dashboard/rolodex");
          })
          .catch(() => {
            toast.error("Failed to publish deletion. Please publish manually.");
          });
      })
      .catch(() => {
        toast.error("Failed to delete rolodex person.");
      });
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Delete Rolodex Person</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete this rolodex person? This action will mark the entry as deleted.
          After deletion, this entry cannot be edited, published, or saved.
          
          The deletion will be automatically published to propagate the changes.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleConfirmDelete} color="error" autoFocus>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteRolodexDialog;
